interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6 border border-dashed border-background-300 rounded-lg bg-background-100">
      <span className="w-14 h-14 rounded-full bg-secondary-100 text-secondary-700 flex items-center justify-center mb-4">
        <i className={`${icon} text-2xl`}></i>
      </span>
      <p className="text-foreground-900 font-medium">{title}</p>
      {description && <p className="text-sm text-foreground-500 mt-2 max-w-md">{description}</p>}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 px-4 h-10 rounded-md bg-primary-600 text-background-50 text-sm hover:bg-primary-700 transition-colors whitespace-nowrap cursor-pointer"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}